import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/sales-plan", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/sales-plan/csv", params);
};

const get = id => {
  return restApi.get(`/api/sales-plan/${id}`);
};

const upsert = data => {
  return restApi.post("/api/sales-plan/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/sales-plan/${ids}`);
};

const salesPlanService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default salesPlanService;